import axios from "axios";

let baseURL = "";

// Detect environment based on window location
const hostname = window.location.hostname;

if (hostname === "localhost") {
  baseURL = "http://localhost:8080/app/";
  //  baseURL = "https://florenceht.com/app/";
  // baseURL = "http://ec2-65-1-81-20.ap-south-1.compute.amazonaws.com:8080/app/";
} else if (hostname === "telemedicine-dc227.web.app") {
  baseURL = "http://ec2-65-1-81-20.ap-south-1.compute.amazonaws.com:8080/app/";
} else if (hostname === "muller-clinic.web.app/") {
  baseURL = "https://mueller4.florenceht.com/app/";
} else {
  baseURL = "https://mueller4.florenceht.com/app/";
}

const AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to include Bearer token
AxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default AxiosInstance;
